import { Button, Card, Descriptions, Dropdown, Flex, Menu } from 'antd';
import dayjs from 'dayjs';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { formatDollarsFromCents } from 'utilities/helpers';

import { getSavingsPercentage } from '../offerHelpers';
import EstimatedPaymentsBreakdown from '../EstimatedPaymentsBreakdown';
import PrecoOfferTitle from './PrecoOfferTitle';
import {
  PRECO_ENROLLMENT_TYPES,
  PRECO_STEPS,
  setNextStep,
  setSelectedOffer,
} from './precoState';

const PrecoOfferCard = ({ offer, outstandingBalance, selectable = true }) => {
  const { enablePrecoPaymentPlans } = useFlags();
  const savingsPercentage = getSavingsPercentage(
    offer.settlementBalance,
    outstandingBalance,
  );

  const onSelectOffer = (enrollmentType) => {
    setSelectedOffer(offer, outstandingBalance, enrollmentType);

    setNextStep(
      enrollmentType === PRECO_ENROLLMENT_TYPES.PAYMENT_PLAN
        ? PRECO_STEPS.FUNDING_ACCOUNT
        : PRECO_STEPS.DISCLOSURE,
    );
  };

  const selectOfferButton = (
    <Button
      type="primary"
      block
      data-testid={`selectOffer-${offer.offerId}`}
      onClick={
        enablePrecoPaymentPlans
          ? undefined
          : () => onSelectOffer(PRECO_ENROLLMENT_TYPES.FLEXIBLE_PLAN)
      }
    >
      Select Offer
    </Button>
  );

  const selectOffer = (
    <Flex
      key="actions"
      justify="center"
      style={{ paddingInline: 'var(--spacing-lg)' }}
    >
      {enablePrecoPaymentPlans ? (
        <Dropdown
          trigger={['click']}
          popupRender={() => (
            <Menu
              items={[
                {
                  key: 'paymentPlan',
                  label: (
                    <Button
                      onClick={() =>
                        onSelectOffer(PRECO_ENROLLMENT_TYPES.PAYMENT_PLAN)
                      }
                      style={{ width: '100%' }}
                    >
                      Payment Plan
                    </Button>
                  ),
                },
                {
                  key: 'flexiblePlan',
                  label: (
                    <Button
                      onClick={() =>
                        onSelectOffer(PRECO_ENROLLMENT_TYPES.FLEXIBLE_PLAN)
                      }
                      style={{ width: '100%' }}
                    >
                      Flexible Plan
                    </Button>
                  ),
                },
              ]}
            />
          )}
        >
          {selectOfferButton}
        </Dropdown>
      ) : (
        selectOfferButton
      )}
    </Flex>
  );

  return (
    <Card
      type="inner"
      style={{ minWidth: 400 }}
      title={<PrecoOfferTitle offer={offer} />}
      actions={selectable ? [selectOffer] : undefined}
    >
      <Descriptions column={1} size="small">
        <Descriptions.Item label="Settlement Balance">
          {formatDollarsFromCents(offer.settlementBalance)}
        </Descriptions.Item>
        <Descriptions.Item label="Outstanding Balance">
          {formatDollarsFromCents(outstandingBalance)}
        </Descriptions.Item>
        <Descriptions.Item label="Total Savings">
          {formatDollarsFromCents(outstandingBalance - offer.settlementBalance)}{' '}
          ({savingsPercentage}% savings)
        </Descriptions.Item>
      </Descriptions>
      <br />
      <strong>Estimated Payments</strong>
      <br />
      <br />
      <EstimatedPaymentsBreakdown
        amount={offer.settlementBalance}
        durationMonths={offer.durationMonths}
        expirationDate={dayjs().add(offer.durationMonths, 'month')}
      />
    </Card>
  );
};

export default PrecoOfferCard;
